export default "__VITE_ASSET__0a1c7a09__"